import { render, staticRenderFns } from "./RequestedDocumentationControlPats.vue?vue&type=template&id=413e66fe&scoped=true"
import script from "./RequestedDocumentationControlPats.vue?vue&type=script&lang=js"
export * from "./RequestedDocumentationControlPats.vue?vue&type=script&lang=js"
import style0 from "./RequestedDocumentationControlPats.vue?vue&type=style&index=0&id=413e66fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413e66fe",
  null
  
)

export default component.exports